import React from "react";
import styles from "./SectionIcons.module.css";
import { MdOutlinePool } from "react-icons/md";
import { TbBeach } from "react-icons/tb";
import { GiCoffeeCup } from "react-icons/gi";
import { HiWifi } from "react-icons/hi2";
import { GiShrimp } from "react-icons/gi";

const SectionWellness = () => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <MdOutlinePool className={styles.icon} />
        <h3 className={styles.title}>Piscina frente al mar</h3>
      </div>
      <div className={styles.section}>
        <TbBeach className={styles.icon} />
        <h3 className={styles.title}>Acceso a la playa</h3>
      </div>
      <div className={styles.section}>
        <GiShrimp className={styles.icon} />
        <h3 className={styles.title}>Zona Gastronómica</h3>
      </div>
      <div className={styles.section}>
        <GiCoffeeCup className={styles.icon} />
        <h3 className={styles.title}>Cafetería</h3>
      </div>
      <div className={styles.section}>
        <HiWifi className={styles.icon} />
        <h3 className={styles.title}>Internet</h3>
      </div>
    </div>
  );
};

export default SectionWellness;
